import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleSolicitarHsAdicionales = React.lazy(
  () =>
    import(
      "../components/task/resultManager/tareaDetalleSolicitarHsAdicionales/tarea-detalle-solicitar-horas-adicionales"
    )
);
export function tareaDetalleSolicitarHorasAdicionales() {
  return (
    <Route
      path="/tarea-detalle-solicitar-horas-adicionales"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <TareaDetalleSolicitarHsAdicionales />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
